const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGreenBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32.0829 55.7517H8.58812C8.26269 55.7517 8 55.489 8 55.1636V7.10765C8 6.78223 8.26269 6.51953 8.58812 6.51953H41.383C41.7084 6.51953 41.9711 6.78223 41.9711 7.10765V25.9562C41.9711 26.2817 41.7084 26.5444 41.383 26.5444C41.0576 26.5444 40.7949 26.2817 40.7949 25.9562V7.69577H9.17624V54.5755H32.0829C32.4083 54.5755 32.671 54.8382 32.671 55.1636C32.671 55.489 32.4083 55.7517 32.0829 55.7517Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2908 19.1789H11.6816C11.3562 19.1789 11.0935 18.9162 11.0935 18.5908V12.6077C11.0935 12.2822 11.3562 12.0195 11.6816 12.0195H38.2908C38.6162 12.0195 38.8789 12.2822 38.8789 12.6077V18.5908C38.8789 18.9149 38.6149 19.1789 38.2908 19.1789ZM12.2697 18.0027H37.7027V13.1958H12.2697V18.0027Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2908 29.5363H11.6816C11.3562 29.5363 11.0935 29.2736 11.0935 28.9482V22.9651C11.0935 22.6396 11.3562 22.377 11.6816 22.377H38.2908C38.6162 22.377 38.8789 22.6396 38.8789 22.9651V28.9482C38.8789 29.2736 38.6149 29.5363 38.2908 29.5363ZM12.2697 28.3601H37.7027V23.5532H12.2697V28.3601Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6869 39.8957H11.6816C11.3562 39.8957 11.0935 39.633 11.0935 39.3076V33.3244C11.0935 32.999 11.3562 32.7363 11.6816 32.7363H35.9592C36.2846 32.7363 36.5473 32.999 36.5473 33.3244C36.5473 33.6499 36.2846 33.9126 35.9592 33.9126H12.2697V38.7195H31.6869C32.0123 38.7195 32.275 38.9822 32.275 39.3076C32.275 39.6317 32.0123 39.8957 31.6869 39.8957Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.507 50.2531H11.6804C11.355 50.2531 11.0923 49.9904 11.0923 49.665V43.6819C11.0923 43.3564 11.355 43.0938 11.6804 43.0938H29.8755C30.201 43.0938 30.4636 43.3564 30.4636 43.6819C30.4636 44.0073 30.201 44.27 29.8755 44.27H12.2698V49.0769H29.5083C29.8337 49.0769 30.0964 49.3396 30.0964 49.665C30.0951 49.9904 29.8324 50.2531 29.507 50.2531Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7463 7.69653C35.4208 7.69653 35.1581 7.43384 35.1581 7.10841V1.17624H14.8144V7.10841C14.8144 7.43384 14.5517 7.69653 14.2263 7.69653C13.9009 7.69653 13.6382 7.43384 13.6382 7.10841V0.58812C13.6382 0.262694 13.9009 0 14.2263 0H35.7463C36.0717 0 36.3344 0.262694 36.3344 0.58812V7.10841C36.3344 7.43384 36.0704 7.69653 35.7463 7.69653Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8756 60.0001C29.5959 60.0001 29.3476 59.7989 29.2966 59.514C29.2404 59.1938 29.4534 58.8892 29.7736 58.833C35.3412 57.8502 38.9836 55.3448 40.5976 51.3848C41.8092 48.4142 41.3766 45.6774 41.3713 45.65C41.3191 45.3298 41.5347 45.0266 41.8549 44.973C42.1751 44.9194 42.4783 45.1351 42.5319 45.4553C42.5528 45.5781 43.0246 48.5043 41.7085 51.7756C40.4944 54.7933 37.4741 58.6684 29.9788 59.991C29.9435 59.9975 29.9095 60.0001 29.8756 60.0001Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3982 57.2556C37.2754 57.2556 37.1538 57.2543 37.0323 57.2504C36.8611 57.2452 36.7003 57.1668 36.5932 57.0335C32.9821 52.5847 31.5693 48.477 32.2764 44.4738C32.8854 41.0248 34.9464 38.2646 36.7644 35.8298C38.7117 33.2224 40.25 31.1627 39.4828 29.1592C39.3874 28.9083 39.4723 28.626 39.6906 28.4704C39.9089 28.3149 40.2042 28.3267 40.4107 28.4992C45.1183 32.454 48.3294 36.3303 49.9539 40.0198C51.389 43.2793 51.5824 46.3336 50.5303 49.0978C48.4902 54.4523 42.3254 57.2556 37.3982 57.2556ZM37.3342 56.0794C37.3538 56.0794 37.3747 56.0794 37.3943 56.0794C41.983 56.0794 47.6459 53.3662 49.4299 48.6795C50.3682 46.2134 50.1827 43.4597 48.877 40.4929C47.4668 37.2883 44.7733 33.9125 40.8616 30.4413C40.774 32.4265 39.3273 34.3647 37.7067 36.5342C34.2655 41.1412 29.9905 46.8668 37.3342 56.0794Z",
    fill: "#231F20",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenBattery);
export default __webpack_public_path__ + "static/media/icon-green-battery.bf8695cafc2e2dd537ff1f10a7f7e905.svg";
export { ForwardRef as ReactComponent };